(() => {
  if (customElements.get('wavs-scan-hero')) return;
  class WavsScanHero extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const opts = { signal: this.controller.signal };
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.art = this.querySelector('[data-art]');
      this.pass = this.querySelector('.wavs-scan__pass');
      this.toggle = this.querySelector('[data-toggle]');
      this.controls = this.querySelector('[data-controls]');
      this.steps = [...this.querySelectorAll('[data-stage-button]')];
      this.elapsed = 0; this.playing = false; this.visible = true;
      this.controls.hidden = false;
      this.toggle.addEventListener('click', () => this.playing ? this.pause() : this.play(this.elapsed >= 12000 ? 0 : this.elapsed), opts);
      this.querySelector('[data-replay-button]').addEventListener('click', () => this.play(0), opts);
      this.steps.forEach((button, index) => button.addEventListener('click', () => {
        this.pause(); this.elapsed = index * 4000;
        this.dataset.motion = 'still'; this.stage(index);
      }, opts));
      this.addEventListener('pointermove', event => {
        if (this.reduced.matches || !this.playing || event.pointerType !== 'mouse') return;
        const box = this.getBoundingClientRect();
        this.style.setProperty('--scan-x', `${(event.clientX - box.left - box.width / 2) / box.width * 14}px`);
        this.style.setProperty('--scan-y', `${(event.clientY - box.top - box.height / 2) / box.height * 10}px`);
      }, opts);
      this.addEventListener('pointerleave', () => this.center(), opts);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden && this.playing) { this.pause(); this.autoResume = true; }
        else if (!document.hidden && this.autoResume && this.visible) { this.autoResume = false; this.play(this.elapsed); }
      }, opts);
      this.reduced.addEventListener('change', () => {
        this.pause(); this.elapsed = 12000; this.stage(2); this.dataset.motion = 'still';
        this.querySelector('.wavs-scan__playback').hidden = this.reduced.matches;
      }, opts);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        if (!this.visible && this.playing) { this.pause(); this.autoResume = true; }
        else if (this.visible && this.autoResume && !document.hidden) { this.autoResume = false; this.play(this.elapsed); }
      }, { threshold: 0.1 });
      this.observer.observe(this);
      this.stage(2); this.updateToggle();
      this.querySelector('.wavs-scan__playback').hidden = this.reduced.matches;
      const image = this.querySelector('.wavs-scan__image');
      const ready = () => {
        if (this.isConnected && this.controller && this.dataset.autoplay === 'true' && !this.reduced.matches) this.play(0);
      };
      if (image.complete && image.naturalWidth) ready();
      else image.addEventListener('load', ready, { ...opts, once: true });
    }
    center() { this.style.setProperty('--scan-x', '0px'); this.style.setProperty('--scan-y', '0px'); }
    stage(index) {
      this.dataset.stage = ['scan', 'shape', 'sound'][index];
      this.steps.forEach((step, i) => step.setAttribute('aria-pressed', String(i === index)));
    }
    updateToggle() {
      this.toggle.setAttribute('aria-label', this.playing ? this.dataset.pause : this.elapsed >= 12000 ? this.dataset.replay : this.dataset.resume);
      this.querySelector('[data-pause-icon]').hidden = !this.playing;
      this.querySelector('[data-play-icon]').hidden = this.playing;
    }
    play(from = 0) {
      if (this.reduced.matches) return;
      cancelAnimationFrame(this.frame);
      this.autoResume = false;
      this.elapsed = from;
      this.dataset.motion = 'still';
      this.style.setProperty('--scan-delay', `${-from / 1000}s`);
      void this.pass.offsetWidth;
      this.dataset.motion = 'playing';
      this.playing = true;
      this.started = performance.now() - from;
      this.updateToggle();
      const tick = now => {
        if (!this.playing) return;
        this.elapsed = Math.min(12000, now - this.started);
        this.stage(Math.min(2, Math.floor(this.elapsed / 4000)));
        if (this.elapsed >= 12000) { this.pause(); this.dataset.motion = 'still'; return; }
        this.frame = requestAnimationFrame(tick);
      };
      this.frame = requestAnimationFrame(tick);
    }
    pause() {
      this.autoResume = false;
      if (this.playing) this.elapsed = Math.min(12000, performance.now() - this.started);
      this.playing = false; cancelAnimationFrame(this.frame);
      this.dataset.motion = 'paused'; this.center(); this.updateToggle();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame); this.observer?.disconnect();
      this.controller?.abort(); this.controller = null;
    }
  }
  customElements.define('wavs-scan-hero', WavsScanHero);
})();
